import React from "react";
import keyboard from "../../Assets/first.png";
import whiteline from "../../Assets/zigzag-w2.png";

const Hero1 = () => {
  return (
    <div className="relative -mt-24">
      {/* Background Image */}
      <div className="w-full  lg:min-h-screen  overflow-hidden">
        <img
          src={keyboard}
          alt="Hero Section Banner"
          className="w-full lg:h-full h-[500px] object-fit brightness-50"
        />
      </div>

      {/* Zigzag Image */}
      <div className="absolute top-[150px] sm:top-[250px] left-[5%] sm:left-[10%] md:left-[25%] z-20 mt-32 sm:mt-40 md:mt-[570px] rotate-12 hidden sm:block transform-gpu">
        <img
          src={whiteline}
          alt="Decorative Zigzag"
          className="w-[80px] sm:w-[100px] md:w-[150px] lg:w-[200px] h-auto"
        />
      </div>
    </div>
  );
};

export default Hero1;
